
export default ({ app }, inject) => {
  inject('convertDate', (date) => {
    const parts = date.split('/')
    const day = parts[0]
    const month = parts[1]
    const year = parts[2]
    const formattedDate = new Date(`${year}-${month}-${day}T23:59:59`)
    return formattedDate
  })
  inject('compareDate', (date) => {
    const dateNow = new Date()
    const currentDate = Date.parse(dateNow)
    const dateLabel = Date.parse(date)
    if (dateLabel >= currentDate) {
      return true
    }
    return false
  })
  inject('convertDateBr', (date) => {
    const [dia, mes, ano] = date.split('/')
    return `${dia}/${mes}/${ano}`
  })
}
